/*eslint-disable*/

export {};

declare global {
  interface Window {
    _env_: EnvVariablesProps;
  }
}

type EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL: string;
  REACT_APP_ACTIVATE_CREDIT_CARD: string;
};

const config: EnvVariablesProps = {
  REACT_APP_PROXY_BASE_URL:
    window._env_?.REACT_APP_PROXY_BASE_URL !== "VARPROXYBASEURL"
      ? window._env_?.REACT_APP_PROXY_BASE_URL
      : process.env.NODE_ENV !== "production"
      ? String(process.env.REACT_APP_PROXY_BASE_URL)
      : `${console.log(
          "The key VARPROXYBASEURL in index.html should be replaced!"
        )} ${window._env_?.REACT_APP_PROXY_BASE_URL}`,

  REACT_APP_ACTIVATE_CREDIT_CARD:
    window._env_?.REACT_APP_ACTIVATE_CREDIT_CARD !== "VARACTIVATECREDITCARD"
      ? window._env_?.REACT_APP_ACTIVATE_CREDIT_CARD
      : process.env.NODE_ENV !== "production"
      ? String(process.env.REACT_APP_ACTIVATE_CREDIT_CARD)
      : `${console.log(
          "The key VARACTIVATECREDITCARD in index.html should be replaced!"
        )} ${window._env_?.REACT_APP_ACTIVATE_CREDIT_CARD}`,
};

export const appConfig = {
  REACT_APP_PROXY_BASE_URL: config.REACT_APP_PROXY_BASE_URL,
  ACTIVATE_CREDIT_CARD: config.REACT_APP_ACTIVATE_CREDIT_CARD,
};
